<template>
    <div class="content-header">
        <div>
            <slot name="header-left">

            </slot>
        </div>
        <div>
            <slot name="header-right"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tableTitle'
}
</script>
<style scoped lang="scss">
.content-header{
    height: 42px;
    border-bottom: 1px solid #DDE0E2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
}
</style>